import React from "react";

export default function NsButtonActionsGroup({children}) {

    return (
        <div role="group"
             aria-label="Button group with nested dropdown">
            <div role="group">
                <button id="btnGroupDrop1" type="button"
                        className="btn btn-dark dropdown-toggle"
                        data-bs-toggle="dropdown" aria-expanded="false">
                    <i className="fa-solid fa-bars"></i>
                </button>
                <ul className="dropdown-menu" aria-labelledby="btnGroupDrop1">
                    {children}
                </ul>
            </div>
        </div>
    )
}